var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.034,22.116c-0.375-0.375-0.884-0.586-1.414-0.586h-8.168V6.127C58.452,4.402,57.05,3,55.325,3h-10.65  c-1.724,0-3.127,1.402-3.127,3.127V21.53H19.12c-1.104,0-2,0.896-2,2V95c0,1.104,0.896,2,2,2H29h42h9.88c1.104,0,2-0.896,2-2V37.79  c0-0.53-0.211-1.039-0.586-1.414L68.034,22.116z M54.452,7v16.511c0,0.007-0.002,0.013-0.002,0.019s0.002,0.013,0.002,0.019v9.803  c0,1.104,0.896,2,2,2h3.557L50,52.688L39.991,35.353h3.557c1.104,0,2-0.896,2-2v-9.808c0-0.005,0.001-0.01,0.001-0.015  s-0.001-0.01-0.001-0.015V7H54.452z M31,93V68h38v25H31z M78.88,93H73V66c0-1.104-0.896-2-2-2H29c-1.104,0-2,0.896-2,2v27h-5.88  V25.53h20.428v5.822h-3.069c-1.114,0-2.152,0.6-2.708,1.564s-0.557,2.163,0,3.126l11.521,19.955  c0.557,0.965,1.594,1.563,2.708,1.563c1.113,0,2.151-0.599,2.708-1.563l11.521-19.955c0.557-0.964,0.557-2.162,0-3.127  c-0.558-0.965-1.595-1.563-2.708-1.563h-3.069V25.53h7.34L78.88,38.618V93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.271,71.5H36.729c-1.104,0-2,0.896-2,2s0.896,2,2,2h26.541c1.104,0,2-0.896,2-2S64.375,71.5,63.271,71.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.271,78.5H36.729c-1.104,0-2,0.896-2,2s0.896,2,2,2h26.541c1.104,0,2-0.896,2-2S64.375,78.5,63.271,78.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.271,85.5H36.729c-1.104,0-2,0.896-2,2s0.896,2,2,2h26.541c1.104,0,2-0.896,2-2S64.375,85.5,63.271,85.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.107ac99ca816427f51e17e0ab130a193.svg";
export { ForwardRef as ReactComponent };